import { Environment, getCountryCodeBookId, getDefaultAppLanguage, Market } from '@leanpay/utils'

// START COMMON CONSTANTS
const getMarketFromHostname = (): Market => {
    const hostname = window.location.hostname

    if (hostname.includes('.leanpay.si') || hostname.includes('slo')) {
        return Market.SLO
    }

    if (hostname.includes('.leanpay.ro') || hostname.includes('rou')) {
        return Market.ROM
    }

    if (hostname.includes('.leanpay.hr') || hostname.includes('cro')) {
        return Market.CRO
    }

    throw new Error(`[MARKET] Unknown hostname: ${hostname}`)
}

const isPrivateIp =
    /^(10\.\d+\.\d+\.\d+|192\.168\.\d+\.\d+|172\.(1[6-9]|2\d|3[01])\.\d+\.\d+)$/.test(
        window.location.hostname,
    )
const isRunningOnLocalhost =
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('127.0.0.1') ||
    isPrivateIp ||
    (window.location.hostname.includes('leanpay') && !window.location.hostname.includes('.'))

export const currentMarket = isRunningOnLocalhost
    ? (import.meta.env.VITE_MARKET as Market)
    : getMarketFromHostname()

export const isMarketSlo = currentMarket === Market.SLO
export const isMarketRom = currentMarket === Market.ROM

const getEnvironmentFromHostname = () => {
    const hostname = window.location.hostname

    if (isRunningOnLocalhost) {
        return Environment.LOCAL
    }

    if (hostname.includes('dev')) {
        return Environment.TILT
    }

    if (hostname.includes('test-verification')) {
        return Environment.TEST
    }
    if (hostname.includes('stage-verification')) {
        return Environment.STAGE
    }

    if (hostname.includes('verification')) {
        return Environment.PROD
    }

    throw new Error(`[ENV] Unknown hostname: ${hostname}`)
}

export const currentEnvironment = getEnvironmentFromHostname()

export const isLocalEnvironment = currentEnvironment === Environment.LOCAL
export const isTestEnvironment = currentEnvironment === Environment.TEST
export const isStageEnvironment = currentEnvironment === Environment.STAGE
export const isProdEnvironment = currentEnvironment === Environment.PROD
export const isNonProdLiveEnvironment = !isProdEnvironment && !isLocalEnvironment

export const defaultAppLanguage = getDefaultAppLanguage(currentMarket)

export const countryCodebookId = getCountryCodeBookId(currentMarket)

// END COMMON CONSTANTS

const getGtmId = () => {
    if (isMarketSlo) {
        return 'GTM-PX8JRJT'
    }

    return ''
}

export const gtmId = getGtmId()

export enum IdentityCardType {
    PERSONAL_ID = 'PERSONAL_ID',
    PASSPORT = 'PASSPORT',
}

export enum CacheKey {
    VerificationStatus = 'VerificationStatus',
    Time = 'Time',
    VerificationInit = 'VerificationInit',
    SessionInfo = 'SessionInfo',
    AdministrativeUnit = 'AdministrativeUnit',
    VerificationConfirm = 'VerificationConfirm',
    Auth = 'Auth',
    RequestOtp = 'RequestOtp',
}

export enum VerificationRoute {
    ChooseLogin = '',
    Email = 'email',
    RequestOtp = 'request-otp',
    Login = 'login',
    InitVerification = 'init-verification',
    ConfirmVerification = 'confirm-verification',
    VerificationStatus = 'verification-status',
}
